const { STATUS_CODE, STATUS_CODE_TEXT } = require("./constants");

export const createSuccessResponse = (data = {}, message = "Success") => {
  return {
    status: STATUS_CODE.SUCCESS,
    messageStatus: STATUS_CODE_TEXT.SUCCESS,
    message,
    data: data && data.data ? data.data : data,
  };
};

export const createErrorResponse = (data = null, message = "Something went wrong with the request") => {
  return {
    status: data && data.status ? data.status : STATUS_CODE.ERROR,
    messageStatus: STATUS_CODE_TEXT.ERROR,
    message,
    data,
  };
};
